import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchSchoolDataByShortName, fetchClubData, fetchFundraiserData } from "../firebase/firestoreUtils";
import "../styles/ClubPage.css";
import AchievementsSlider from "../components/AchievementsSlider";
import SponsorCard from "../components/SponsorCard";
import UpcomingEvents from "../components/UpcomingEvents";
import SponsorsList from "../components/SponsorsList";
import PastParticipation from "../components/PastParticipation";
import StudentMembers from "../components/StudentMembers";
import TeachersList from "../components/TeachersList";
import ClubAbout from "../components/ClubAbout";
import robotikLogo from '../images/sktpp2_robotik.png';
import Header from "../components/Header";





function ClubPage() {
    const { schoolShortName, clubName } = useParams();
    const [schoolData, setSchoolData] = useState(null);
    const [clubData, setClubData] = useState(null);
    const [fundraiser, setFundraiser] = useState(null);

    console.log("🛠 Debug: fundraiserId before rendering SponsorCard:", fundraiser?.id);

    useEffect(() => {
        let unsubscribeSchool = () => { };
        let unsubscribeClub = () => { };
        let unsubscribeFundraiser = () => { };

        if (schoolShortName) {
            fetchSchoolDataByShortName(schoolShortName, (data) => {
                console.log("🏫 Fetched School Data:", data);
                setSchoolData(data);

                if (data?.id) {
                    const clubUnsub = fetchClubData(data.id, clubName, (clubData) => {
                        console.log("🎓 Fetched Club Data:", clubData);
                        setClubData(clubData);
                    });

                    const fundraiserUnsub = fetchFundraiserData(data.id, clubName, (fundraiserData) => {
                        if (!fundraiserData || !fundraiserData.id) {
                            console.error("⚠️ Fundraiser data is missing or has no ID:", fundraiserData);
                            return;
                        }

                        console.log("💰 Fetched Fundraiser Data:", fundraiserData);

                        // ✅ Inject `schoolShortName` into fundraiser
                        setFundraiser({ ...fundraiserData, schoolShortName });
                    });


                    unsubscribeClub = clubUnsub || (() => { });
                    unsubscribeFundraiser = fundraiserUnsub || (() => { });
                }
            }).then((unsub) => {
                unsubscribeSchool = unsub || (() => { });
            });
        }

        return () => {
            console.log("🧹 Cleaning up listeners...");
            if (typeof unsubscribeSchool === "function") unsubscribeSchool();
            if (typeof unsubscribeClub === "function") unsubscribeClub();
            if (typeof unsubscribeFundraiser === "function") unsubscribeFundraiser();
        };
    }, [schoolShortName, clubName]);


    if (!schoolData || !clubData) {
        return (
            <div className="loading-wrapper">
                <div className="loading-circle">
                    <img src={robotikLogo} alt="Loading Logo" className="loading-logo" />
                </div>
            </div>

        );
    }

    return (
        <div className="container">



            <Header schoolData={schoolData} clubData={clubData} />

            <div className="main-content">
                <div className="left-column">
                    <h2>Achievements</h2>
                    <AchievementsSlider clubData={clubData} />
                    <PastParticipation clubData={clubData} />
                    <StudentMembers clubData={clubData} />
                </div>

                <div className="right-column">
                    {/* ✅ Pass `schoolShortName` to SponsorCard */}
                    {fundraiser && fundraiser.id && fundraiser.is_active && (
                        <>                    <h2>Sponsorship Needed</h2>

                            <SponsorCard
                                fundraiser={fundraiser}
                                fundraiserId={fundraiser.id}
                                schoolShortName={schoolShortName}
                            />
                        </>
                    )}



                    <ClubAbout clubData={clubData} />

                    <TeachersList clubData={clubData} />
                    <UpcomingEvents clubData={clubData} />
                    {fundraiser && fundraiser.id && !fundraiser.is_active && (
                        <div style={{ marginTop: "30px" }}>
                            <h3 style={{ marginBottom: "10px" }}>Previous Fundraiser</h3>
                            <SponsorCard
                                fundraiser={fundraiser}
                                fundraiserId={fundraiser.id}
                                schoolShortName={schoolShortName}
                                hideReadMore={true} // 👉 optional prop to hide readmore button
                            />
                        </div>
                    )}

                </div>
            </div>

            <SponsorsList sponsors={clubData.sponsors || []} />

            <footer className="footer">
                <p>© 2025 KOKU.my <br />All rights reserved.</p>
            </footer>
        </div>
    );
}

export default ClubPage;
